import { useState } from "react"

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange"> {
  defaultActiveKey?: string
  items: {
    key?: string
    label?: string
    children?: any
  }[]
  onChange?: (key?: string) => void
}

export function Tabs(props: Props) {

  const { className, onChange, items, defaultActiveKey, ...rest } = props
  const [activeKey, setActiveKey] = useState<string>(defaultActiveKey || "")
  const activeTab = items.find((item) => item.key === activeKey)

  const selectTab = (key?: string) => {
    setActiveKey(key || "")
    onChange?.(key)
  }

  const onKeyDown = (event: React.KeyboardEvent, index: number) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return
    event.preventDefault()
    const dir = event.key === "ArrowRight" ? 1 : -1
    const nextIndex = (index + dir + items.length) % items.length
    const nextKey = items[nextIndex]?.key
    selectTab(nextKey)
    document.getElementById(`tab-${nextKey}`)?.focus()
  }

  return <div className={className} {...rest}>
    <div role="tablist" className="w-full flex gap-4 mb-4">
      {items.map((item, index) => {
        const selected = item.key === activeTab?.key
        return <button
          key={item.key}
          id={`tab-${item.key}`}
          role="tab"
          type="button"
          aria-selected={selected}
          aria-controls={`tabpanel-${item.key}`}
          tabIndex={selected ? 0 : -1}
          onClick={() => selectTab(item.key)}
          onKeyDown={(e) => onKeyDown(e, index)}
          className={selected
            ? "cursor-pointer pb-2 border-0 border-b-2 border-blue-500 border-solid text-blue-500 text-sm"
            : "cursor-pointer pb-2 border-0 text-sm"}
        >{item.label}</button>
      })}
    </div>
    <div role="tabpanel" id={`tabpanel-${activeTab?.key}`} aria-labelledby={`tab-${activeTab?.key}`} tabIndex={0}>
      {activeTab?.children || null}
    </div>
  </div>

}
